import api from '@/utils/api';

/**
 * 投稿相关接口
 */

/**
 * 提交投稿
 * @param {Object} data - 投稿表单数据
 * @returns {Promise}
 */
export function addSubmission(data) {
  return api.post('/submission/add', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

/**
 * 编辑投稿
 * @param {Object} data - 投稿表单数据（必须包含id字段）
 * @returns {Promise}
 */
export function editSubmission(data) {
  return api.post('/submission/edit', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

/**
 * 获取投稿列表
 * @param {Object} params - 查询参数
 * @param {string} params.page - 页码
 * @param {string} params.limit - 每页数量
 * @returns {Promise}
 */
export function getSubmissionList(params) {
  return api.get('/submission/index', {
    params: {
      page: params.page || '1',
      limit: params.limit || '10'
    }
  });
}

/**
 * 获取投稿详情
 * @param {string} id - 投稿ID
 * @returns {Promise}
 */
export function getSubmissionDetail(id) {
  return api.get('/submission/detail', {
    params: { id }
  });
}

/**
 * 删除投稿
 * @param {string|number} id - 投稿ID
 * @returns {Promise}
 */
export function deleteSubmission(id) {
  const formData = new FormData();
  formData.append('id', id);
  return api.post(`/submission/delete?id=${id}`, formData);
}

/**
 * 获取投稿记录详情
 * @param {string|number} id - 投稿ID
 * @returns {Promise}
 */
export function getSubmissionRecordDetail(id) {
  return api.get('/submission/getDetail', {
    params: { id }
  });
}

/**
 * 发送邮箱
 * @param {Object} data - 请求参数
 * @param {string} data.submission_id - 投稿ID，若提供则会把该投稿下所有平台记录追加到发送队列
 * @returns {Promise}
 */
export function sendEmail(data) {
  const formData = new FormData();
  formData.append('submission_id', data.submission_id);
  return api.post('/submission/sendEmail', formData, {
    timeout: 0,
  });
}

/**
 * 设置投稿发送间隔
 * @param {Object} data - 请求参数
 * @param {string|number} data.id - 投稿 ID
 * @param {string|number} data.mail_send_interval_minutes - 发送间隔分钟（空字符串表示恢复站点默认）
 * @returns {Promise}
 */
export function updateSendInterval(data) {
  const formData = new FormData();
  formData.append('id', data.id);
  formData.append(
    'mail_send_interval_minutes',
    data.mail_send_interval_minutes == null
      ? ''
      : String(data.mail_send_interval_minutes)
  );
  return api.post('/submission/updateSendInterval', formData);
}

/**
 * 一键重发失败邮件
 * @param {Object} data - 请求参数
 * @param {string|number} data.submission_id - 投稿 ID
 * @returns {Promise}
 */
export function resendFailedEmails(data) {
  const formData = new FormData();
  formData.append('submission_id', data.submission_id);
  // 服务端可能长时间同步处理，覆盖实例默认 10s 超时；0 表示不设置 XHR 超时，直到有响应
  return api.post('/submission/resendFailedEmails', formData, {
    timeout: 0,
  });
}

